// Utils
import { getArrayOfNestedPropertyValuesRecursively } from './getArrayOfNestedPropertyValuesRecursively';
import { has } from '../has';
import { normalisePath } from '../normalisePath';
/**
 * @description Get values at path specified from nestable object (ex.invoice_lines) as array
 *
 * @template T
 * @param {T} obj
 *
 * @param {string} nestedObjectKey - key of nestable object
 * @param {string[]} keysToFind - array of keys to find at target path
 * @param {string} targetPath - use this if you need to traverse a further than the target object
 *
 * @example
 * getArrayOfValuesFromNestedObject({nestable: {id: 1}}, 'nestable', ['id']);
 * // return [{ id : 1 }]
 *
 * getArrayOfValuesFromNestedObject({nestable: {target: {id : 2}}}, 'nestable', ['id'], 'target');
 * // return [{ id : 2 }]
 *
 * getArrayOfValuesFromNestedObject({nestable: {target: {id : 2}}}, 'nestable', ['id'], 'target');
 * // return [{ id : 2 }]
 *
 * getArrayOfValuesFromNestedObject({id: 1, nestable:{id: 2, nestable:{id: 3}}]}, 'nestable', ['id']);
 * // return [{ id : 2 }, { id : 3 }]
 *
 * getArrayOfValuesFromNestedObject(
 *   {
 *     nestable: [
 *       {id: 1, nestable: [{id: 11}]},
 *       {id: 2, nestable: [{id: 11}, {id: 21}, {id: 22}]},
 *       {id: 3},
 *       {id: 4, nestable: [{id: 41, nestable: [{id: 441}]}]},
 *     ]
 *   },
 *   'nestable',
 *   ['id']
 * );
 * // return [{ id : 2 }, { id : 11 }, { id : 2 }, { id : 11 }, { id : 21 }, { id : 22 }, { id : 3 }, { id : 4 }, { id : 41 }, { id : 441 }]
 *
 * @return {any[]}  {Array<any>}
 */
export var getArrayOfValuesFromNestedObject = function (obj, nestedObjectKey, keysToFind, targetPath) {
    if (targetPath === void 0) { targetPath = ''; }
    if (!has(obj, nestedObjectKey)) {
        return [];
    }
    return getArrayOfNestedPropertyValuesRecursively(obj[nestedObjectKey], nestedObjectKey, keysToFind, normalisePath(targetPath));
};
//# sourceMappingURL=getArrayOfValuesFromNestedObject.js.map